export function Webinar(model = {}) {
  return {
    id: model?.id,
    subject: model?.subject,
    registrationUrl: model?.registrationUrl,
    description: model?.description,
    startTime: model?.startTime,
    endTime: model?.endTime
  };
}

export function setWebinarFromRequest(raw = {}) {
  const model = Webinar();

  model.id = raw?.id;
  model.subject = raw?.subject;
  model.registrationUrl = raw?.registration_url;
  model.description = raw?.description;
  model.startTime = raw?.start_time;
  model.endTime = raw?.end_time;

  return model;
}
